import { DatePicker } from 'antd';
import styled from 'styled-components';

const { RangePicker } = DatePicker;

export const DateRangePickerContainer = styled(RangePicker)`
  width: 100%;
`;
